export default "__VITE_ASSET__dc978432__"